/**
 * THE side gutter of a full-width WORK page from `md` up (owner 2026-10-05:
 * "reducing the border/padding/margin on the sides … make it wider … this will
 * likely affect all pages").
 *
 * 10px — the value To Approve and the three Hires pages already used
 * (`p-2.5`), so they are the reference and the order / Breakdown / My Tasks /
 * budget pages (which were `md:p-4 lg:p-6`, 16–24px) were brought to it.
 * APPEND it after a page's own `p-*` classes: WITHIN ONE VARIANT Tailwind
 * emits `px-*` after `p-*`, so it overrides only the horizontal padding.
 * 🪤 ACROSS variants it does NOT: `lg:p-6` is emitted after `md:px-2.5`, so a
 * `md:`-only gutter loses at ≥1024px — it shipped that way on 2026-10-05 and
 * applied only at 768–1023px (measured in the built CSS by review). A
 * responsive override must REPEAT at every breakpoint where the page's base
 * `p-*` repeats; every consumer carries `md:p-*` AND `lg:p-*`, hence both
 * tokens below. Pinned by `pageLayout.test.js`. Vertical padding and
 * the phone gutters (`p-2`, `max-md:px-[5px]`, `PHONE_FULL_BLEED`) are
 * untouched. Centred max-width pages (New Order, the order page, Grading,
 * Marketplace) and the dashboards do not use it — their width is capped, so a
 * gutter buys them nothing.
 */
export const PAGE_SIDE_GUTTER = 'md:px-2.5 lg:px-2.5';

/**
 * THE page shell of a list/work page with a phone header (`MobileTabSearchRow`):
 * side gutter as above, no top padding under the app bar, the phone's 5px
 * gutter and room for the phone nav. Extracted 2026-10-25 from two
 * byte-identical copies (My Tasks, Timesheets) so a new list page stops
 * re-deciding its padding (owner, Timesheets build). Both render the same
 * string they did before.
 */
export const LIST_PAGE_SHELL =
  `max-w-full p-2 max-md:pt-0 max-md:px-[5px] pb-20 md:p-4 md:pt-0 md:pb-6 lg:p-6 lg:pt-0 ${PAGE_SIDE_GUTTER}`;
